import type { SxProps, Theme } from '@mui/material/styles';

type CustomerTransferDetailStyleMap = {
    loadingContainer: SxProps<Theme>
    root: SxProps<Theme>
    header: SxProps<Theme>
    headerSpacer: SxProps<Theme>
    card: SxProps<Theme>
    cardHeader: SxProps<Theme>
    ownersGrid: SxProps<Theme>
};

type CustomerTransferInfoRowStyleMap = {
    root: SxProps<Theme>
};

export const customerTransferDetailStyles: CustomerTransferDetailStyleMap = {
    loadingContainer: { display: 'flex', justifyContent: 'center', mt: 8 },
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    header: { display: 'flex', alignItems: 'center', gap: 2 },
    headerSpacer: { flexGrow: 1 },
    card: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    cardHeader: { px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider' },
    ownersGrid: { display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 3 },
};

export const customerTransferInfoRowStyles: CustomerTransferInfoRowStyleMap = {
    root: { px: 3, py: 2, display: 'grid', gridTemplateColumns: '200px 1fr', gap: 2, alignItems: 'start' },
};
